(() => {
  'use strict';
  if (window.CJNZPreorder) return;
  const source = document.getElementById('cjnz-preorder-config');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const records = config.variants || {};
  const pending = new WeakSet();
  const approvals = new WeakMap();
  const lookup = id => records[String(id)] && records[String(id)].active ? records[String(id)] : null;
  const isJumper = id => { const record = lookup(id); return !!record && record.kind === 'jumper'; };
  const getId = form => { const input = form.querySelector('[name="id"]'); return input && input.value; };
  const selected = form => form.dataset.requireSizeSelection !== 'true' || !!(form.querySelector('[data-size-selector]') || {}).value;
  const message = label => 'Your whole order, including in-stock items, will be held and shipped together when everything is available. Expected dispatch from ' + label + '. A later pre-order date or longer personalised-item lead time may apply.';
  function propertiesFor(id) {
    const record = lookup(id);
    if (!record || record.kind !== 'jumper') return {};
    return {'Pre-order': 'Expected dispatch ' + record.label + '; whole order ships together', '_cjnz_preorder_batch': config.batch, '_cjnz_preorder_date': record.date, '_cjnz_preorder_ack': 'confirmed'};
  }
  function clearProperties(form) { form.querySelectorAll('[data-cjnz-preorder-property]').forEach(input => input.remove()); }
  function setProperties(form, id) {
    clearProperties(form);
    Object.entries(propertiesFor(id)).forEach(([key, value]) => {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'properties[' + key + ']'; input.value = value; input.dataset.cjnzPreorderProperty = 'true'; form.appendChild(input);
    });
  }
  function latest(items) {
    return (items || []).map(item => lookup(item.variant_id || item.id)).filter(Boolean).sort((a,b) => b.date.localeCompare(a.date))[0] || null;
  }
  let dialog, resolveDialog, previousFocus;
  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog'); dialog.className = 'cjnz-preorder-dialog'; dialog.setAttribute('aria-labelledby', 'cjnz-preorder-title'); dialog.setAttribute('aria-describedby', 'cjnz-preorder-policy');
    dialog.innerHTML = '<div class="cjnz-preorder-dialog__inner"><p class="cjnz-preorder-dialog__eyebrow">Please check before adding</p><h2 id="cjnz-preorder-title">This item is a pre-order</h2><p data-preorder-dialog-product></p><p class="cjnz-preorder-dialog__date" data-preorder-dialog-date></p><p id="cjnz-preorder-policy"></p><p class="cjnz-preorder-dialog__preview" data-preorder-dialog-preview hidden>Preview only. No item will be added and no stock will change.</p><div class="cjnz-preorder-dialog__buttons"><button type="button" class="button" data-preorder-confirm>Confirm pre-order</button><button type="button" class="button altcolour" data-preorder-cancel>Cancel</button></div></div>';
    document.body.appendChild(dialog);
    dialog.querySelector('[data-preorder-confirm]').addEventListener('click', () => finish(true));
    dialog.querySelector('[data-preorder-cancel]').addEventListener('click', () => finish(false));
    dialog.addEventListener('cancel', event => { event.preventDefault(); finish(false); });
    return dialog;
  }
  function finish(accepted) {
    if (!resolveDialog) return;
    const resolve = resolveDialog; resolveDialog = null; dialog.close();
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll:true});
    resolve(accepted);
  }
  async function confirmItems(items, preview = false) {
    const matches = (items || []).map(item => lookup(item.variant_id || item.id)).filter(record => record && record.kind === 'jumper');
    if (!matches.length) return true;
    if (resolveDialog) return false;
    const modal = getDialog();
    const last = matches.slice().sort((a,b) => b.date.localeCompare(a.date))[0];
    modal.querySelector('[data-preorder-dialog-product]').textContent = matches.map(record => record.title + ' · ' + record.size).join(', ');
    modal.querySelector('[data-preorder-dialog-date]').textContent = 'Expected dispatch ' + last.label;
    modal.querySelector('#cjnz-preorder-policy').textContent = message(last.label);
    modal.querySelector('[data-preorder-dialog-preview]').hidden = !preview;
    modal.querySelector('[data-preorder-confirm]').textContent = preview ? 'Confirm preview' : 'Confirm pre-order';
    previousFocus = document.activeElement;
    return new Promise(resolve => { resolveDialog = resolve; modal.showModal(); modal.querySelector('[data-preorder-cancel]').focus(); });
  }
  function updateForm(form) {
    if (!form) return;
    const id = getId(form), record = selected(form) && isJumper(id) ? lookup(id) : null;
    const changed = form.dataset.cjnzPreorderVariant !== String(id);
    if (changed || !record) { clearProperties(form); approvals.delete(form); }
    form.dataset.cjnzPreorderVariant = String(id);
    form.classList.toggle('cjnz-preorder-active', !!record);
    const productArea = form.closest('.product-detail');
    const transit = productArea && productArea.querySelector('[data-cjnz-preorder-transit] strong');
    if (transit) transit.textContent = record ? 'NZ delivery after dispatch: 1–3 business days urban, 2–4 rural.' : 'NZ delivery: 1–3 business days urban, 2–4 rural.';
    const note = form.querySelector('[data-cjnz-preorder-product]');
    if (note) {
      note.hidden = !record;
      if (record) {
        note.querySelector('[data-preorder-date]').textContent = record.label;
        const button = form.querySelector('.quantity-submit-row__submit [type="submit"]');
        const unavailable = !button || button.disabled;
        note.querySelector('[data-preorder-unavailable]').hidden = !unavailable;
        const review = note.querySelector('[data-preorder-preview]');
        if (review) review.hidden = !unavailable;
      }
    }
    if (record) {
      const button = form.querySelector('.quantity-submit-row__submit [type="submit"]');
      if (button && !button.disabled && !button.classList.contains('inverted')) { if (button.tagName === 'INPUT') button.value = 'Pre-order'; else button.textContent = 'Pre-order'; }
    }
  }
  function guardForm(form, resume) {
    const id = getId(form);
    if (!selected(form) || !isJumper(id)) { clearProperties(form); approvals.delete(form); return false; }
    if (approvals.get(form) === String(id)) { approvals.delete(form); setProperties(form, id); return false; }
    if (pending.has(form)) return true;
    pending.add(form);
    confirmItems([{id}]).then(accepted => {
      pending.delete(form);
      if (!accepted || String(getId(form)) !== String(id) || !selected(form)) return;
      approvals.set(form, String(id)); resume();
    });
    return true;
  }
  function updateQuickAdds() {
    document.querySelectorAll('[data-cjnz-family-quick-add], [data-cjnz-addon-card]').forEach(card => {
      const family = card.hasAttribute('data-cjnz-family-quick-add');
      const button = card.querySelector(family ? '[data-family-add]' : '[data-cjnz-addon-add]');
      const checked = card.querySelector(family ? 'input[type="radio"]:checked' : '[data-cjnz-addon-size]:checked');
      const id = checked ? checked.value : button && button.dataset.variantId;
      const record = isJumper(id) ? lookup(id) : null;
      let note = card.querySelector('[data-cjnz-preorder-quick]');
      if (!record) { if (note) note.remove(); if(button && button.dataset.cjnzPreorderLabel){button.textContent=button.dataset.cjnzPreorderLabel;delete button.dataset.cjnzPreorderLabel;} return; }
      if (!note) { note = document.createElement('p'); note.className = 'cjnz-preorder-line'; note.dataset.cjnzPreorderQuick = 'true'; button.insertAdjacentElement('beforebegin', note); }
      note.textContent = 'Pre-order · Expected dispatch ' + record.label + '. Your whole order ships together.';
      if (button && !button.disabled && card.dataset.busy !== 'true') { if(!button.dataset.cjnzPreorderLabel)button.dataset.cjnzPreorderLabel=button.textContent; button.textContent = 'Pre-order'; }
    });
  }
  function decoratePopup(popup, cart, item) {
    const record = lookup(item.variant_id || item.id);
    if (record) { const line = document.createElement('p'); line.className='cjnz-preorder-line'; line.textContent='Pre-order · Expected dispatch '+record.label; popup.querySelector('.cart-summary-overlay__variants').appendChild(line); }
    const last = latest(cart.items);
    if (!last) return;
    const note = document.createElement('div'); note.className = 'cjnz-preorder-note cjnz-preorder-popup';
    const heading = document.createElement('strong'); heading.textContent = 'Your whole order will ship together';
    const copy = document.createElement('p'); copy.textContent = message(last.label); note.append(heading,copy);
    popup.querySelector('.cart-summary-overlay__actions').prepend(note);
  }
  window.CJNZPreorder = {isJumper, propertiesFor, latest, updateForm, updateQuickAdds, guardForm, confirmItems, confirmVariant:id => confirmItems([{id}]), decoratePopup};
  function refresh() { document.querySelectorAll('form[data-product-id]').forEach(updateForm); updateQuickAdds(); }
  document.addEventListener('click', event => {
    const preview = event.target.closest('[data-preorder-preview]');
    if (preview) { event.preventDefault(); const form = preview.closest('form'); if (form) confirmItems([{id:getId(form)}],true); }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[data-product-id]')) return;
    if (window.theme && theme.settings.cart_type === 'drawer' && form.dataset.ajaxAddToCart === 'true') return;
    if (guardForm(form, () => form.requestSubmit())) { event.preventDefault(); event.stopImmediatePropagation(); }
  },true);
  document.addEventListener('change', () => setTimeout(refresh,0));
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('cart:updated', refresh);
  if(window.jQuery) window.jQuery(document).on('variantChanged.cjnzPreorder', '[name="id"]', function(){updateForm(this.closest('form'));});
  let timer;
  new MutationObserver(mutations => { if(mutations.some(m => Array.from(m.addedNodes).some(n => n.nodeType===1 && (n.matches('form,[data-cjnz-addon-card],[data-cjnz-family-quick-add]') || n.querySelector('form,[data-cjnz-addon-card],[data-cjnz-family-quick-add]'))))) {clearTimeout(timer);timer=setTimeout(refresh,0);} }).observe(document.body,{childList:true,subtree:true});
  refresh();
})();
